import { createFeatureSelector, createSelector } from '@ngrx/store';

import { CART_ADDITIONAL_FIELDS_FEATURE } from './cart-additional-fields-feature.constant';
import { CartAdditionalFieldsState } from './cart-additional-fields-state.type';

export const featureSelector = createFeatureSelector<CartAdditionalFieldsState>(CART_ADDITIONAL_FIELDS_FEATURE);

export const expandedAdditionalFieldsSelector = createSelector(featureSelector, ({ expanded }) => expanded);
export const additionalFieldsSelector = createSelector(featureSelector, ({ fields }) => fields);
export const entriesValuesSelector = createSelector(featureSelector, ({ entriesValues }) => entriesValues);
export const selectedEntriesSelector = createSelector(featureSelector, ({ selectedEntries }) => selectedEntries);
export const isOneShippingDeliverySelector = createSelector(
  featureSelector,
  ({ isOneShippingDelivery }) => isOneShippingDelivery
);
